import { render, staticRenderFns } from "./RtRouteMaterialEdit.vue?vue&type=template&id=5978b67f&scoped=true&"
import script from "./RtRouteMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./RtRouteMaterialEdit.vue?vue&type=script&lang=js&"
import style0 from "./RtRouteMaterialEdit.vue?vue&type=style&index=0&id=5978b67f&prod&lang=scss&scoped=true&"
import style1 from "./RtRouteMaterialEdit.vue?vue&type=style&index=1&id=5978b67f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5978b67f",
  null
  
)

export default component.exports